var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{on:{"click":_vm.openArticle}},[_c('header',[_c('h2',[_vm._v(_vm._s(_vm.article.title))]),_vm._v(" "),_c('footer',[_vm._v(_vm._s(_vm._f("format_datetime")(_vm.article.published,'Do MMMM YYYY')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.article.teaser))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21db5a99","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/articles-teaser.vue
// module id = lkxp
// module chunks = 1